export const menuItems = [
    {
        id: 1,
        label: 'menuitems.dashboards.text',
        link: '/',
        icon: 'bx-home-circle',
    },
    {
        id: 5,
        label: 'Malware',
        icon: 'bx-tone',
        link: '/malware',
        // isUiElement: true,
        // subItems: [
        //     {
        //         id: 6,
        //         label: 'Malware Analysis Queue',
        //         link: '/malware',
        //         parentId: 5
        //     },
        //     {
        //         id: 7,
        //         label: 'Malware Data Raw',
        //         link: '/malware',
        //         parentId: 5
        //     },
        // ]
    },
    {
        id: 23,
        label: 'malware.manage-report-analysis',
        icon: 'bx-customize',
        link: '/malware/report-analysis',
        relatedlink: ['/malware/detail-report', '/malware/create-report']
    },
    {
        id: 24,
        label: 'malware.manage-users',
        link: '/malware/user',
        icon: 'bx-user',
        relatedlink: ['/malware/user/detail']
    },
    {
        id: 25,
        label: 'malware.setting',
        link: '/malware/setting',
        icon: 'bx-cog',
    },
    {
        id: 30,
        label: 'Documentation',
        link: 'http://xbit.api.xyz/api/documentation',
        icon: 'bx-file-blank',
    },

];